/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { getTagSetFromGroupedKey } from './getTagsetFromGroupKey'

const ASSIGNMENT_GROUP_POS = 0

export const getCopy = (content: any) => {
  if (!content) return {}
  return JSON.parse(JSON.stringify(content))
}

const filterProcessData = (
  data: any,
  accountType: ClientAccountType | null
) => {
  const filteredResponse = data?.response?.filter((subData: any) => {
    return (
      (accountType === 'enterprise' && subData.filter !== 'standard') ||
      (accountType === 'standard' && subData.filter !== 'enterprise')
    )
  })

  return {
    response: filteredResponse,
    category: data.category
  }
}

const checkIfAssignmentVerticalExists = (rootJSON: any, matchingID: string) => {
  let isMatched = false
  rootJSON?.body?.forEach((rootItem: any) => {
    rootItem?.group?.dataset?.forEach((rootDataSetItem: any) => {
      if (!isMatched) {
        isMatched = rootDataSetItem.id === matchingID
      }
    })
  })
  return isMatched
}

const getExperienceKey = (category: number) => {
  switch (category) {
    case 1: {
      return 'experience_level_text'
    }
    case 2: {
      return 'experience_level_design'
    }
    case 3: {
      return 'experience_level_translation'
    }
    default:
      return 'experience_level'
  }
}

const checkIftVerticalExists = (rootJSON: any, matchingID: string) => {
  let isMatched = false
  let matchedIndex = -1
  rootJSON?.response?.forEach((rootItem: any, rootIndex: number) => {
    if (isMatched) {
      return null
    }
    const tempMatched = checkIfAssignmentVerticalExists(rootItem, matchingID)
    if (tempMatched) {
      isMatched = true
      matchedIndex = rootIndex
    }
  })
  return {
    isMatched,
    matchedIndex
  }
}

export const verticalMap = (
  rootVerticalData: any,
  additionalVerticalData: any,
  userType: ClientAccountType | null,
  assignmentStepPosition: 1 | 2
): any => {
  rootVerticalData = getCopy(filterProcessData(rootVerticalData, userType))
  additionalVerticalData = getCopy(
    filterProcessData(additionalVerticalData, userType)
  )
  const completeVerticalData = getCopy(rootVerticalData)
  const rootVerticalAssignmentData =
    rootVerticalData.response[assignmentStepPosition]
  const additionalVerticalAssignmentData =
    additionalVerticalData.response[assignmentStepPosition]
  const finalVerticalAssignment = getCopy(rootVerticalAssignmentData)
  additionalVerticalAssignmentData?.body.forEach(
    (additionalVerticalAssignmentData: any) => {
      additionalVerticalAssignmentData?.group?.dataset?.forEach(
        (additionalVerticalFieldItem: any) => {
          const isMatched = checkIfAssignmentVerticalExists(
            finalVerticalAssignment,
            additionalVerticalFieldItem.id
          )
          if (!isMatched) {
            finalVerticalAssignment?.body?.[
              ASSIGNMENT_GROUP_POS
            ]?.group?.dataset.push(additionalVerticalFieldItem)
          }
        }
      )
    }
  )
  additionalVerticalData?.response?.forEach(
    (additionalVerticalItem: any, additionIndex: number) => {
      if (additionIndex <= assignmentStepPosition) {
        return null
      }
      const additionalFieldSet: any[] = []
      let additionalFieldRootIndex = additionIndex
      additionalVerticalItem?.body?.forEach(
        (additionalVerticalBodyItem: any) => {
          additionalVerticalBodyItem?.group?.dataset?.forEach(
            (additionalVerticalFieldItem: any) => {
              const { isMatched, matchedIndex } = checkIftVerticalExists(
                completeVerticalData,
                additionalVerticalFieldItem.id
              )
              if (
                (isMatched && matchedIndex <= assignmentStepPosition) ||
                !isMatched
              ) {
                additionalFieldSet.push(additionalVerticalFieldItem)
              } else {
                additionalFieldRootIndex = matchedIndex
                const experienceCategoryKey = getExperienceKey(
                  additionalVerticalData?.category
                )
                const checkSubExExists = checkIftVerticalExists(
                  completeVerticalData,
                  experienceCategoryKey
                )
                if (
                  additionalVerticalFieldItem.id === 'experience_level' &&
                  !checkSubExExists.isMatched
                ) {
                  additionalFieldSet.push({
                    ...additionalVerticalFieldItem,
                    id: experienceCategoryKey
                  })
                }
              }
            }
          )
        }
      )

      if (additionalFieldSet?.length) {
        completeVerticalData?.response?.[additionalFieldRootIndex]?.body?.push({
          group: {
            dataset: additionalFieldSet
          }
        })
      }
    }
  )
  completeVerticalData?.response.splice(
    assignmentStepPosition,
    1,
    finalVerticalAssignment
  )
  if (additionalVerticalData?.category === 3) {
    const TRANSLATION_RESPONSE_POSITION = 0
    const TRANSLATION_GROUP_POSITION = 0
    const TRANSLATION_DATASET_ID = 'translation_languages_target_id'
    const findLanguage = additionalVerticalData?.response?.[
      TRANSLATION_RESPONSE_POSITION
    ]?.body?.[TRANSLATION_GROUP_POSITION]?.group?.dataset?.find(
      (verticalDt: { id: string }) => verticalDt?.id === TRANSLATION_DATASET_ID
    )
    if (findLanguage) {
      completeVerticalData?.response?.[2]?.body?.[0]?.group?.dataset?.splice(
        0,
        0,
        findLanguage
      )
    }
  }
  return {
    completeVerticalData,
    rootVerticalData,
    additionalVerticalData
  }
}

export const getAssignmentSpecificBrief = (
  keySet: any,
  assignmentData: any,
  assignmentStepPosition: 1 | 2
) => {
  const assignmentKeySet =
    keySet.response[assignmentStepPosition]?.body?.[ASSIGNMENT_GROUP_POS]?.group
      ?.dataset
  const keys: string[] = []
  assignmentKeySet?.forEach(
    (_keySet: {
      id: string
      tagField?: string
      body?: {
        id: string
        tagField?: string
      }[]
    }) => {
      keys.push(_keySet.id)
      if (_keySet.tagField) {
        keys.push(_keySet.tagField)
      }
      if (Number(_keySet.body?.length) > 0) {
        _keySet.body?.forEach(subIt => {
          subIt?.id && keys.push(subIt.id)
          if (subIt?.tagField) {
            keys.push(subIt.tagField)
          }
        })
      }
    }
  )
  let assignmentBrief: any = {}

  keys?.forEach(keyItem => {
    if (Object.prototype.hasOwnProperty.call(assignmentData, keyItem)) {
      assignmentBrief = {
        ...assignmentBrief,
        [keyItem]: assignmentData[keyItem]
      }
    }
  })
  return assignmentBrief
}

const getTagsArray = ({
  keySet,
  isAssignment,
  isProject
}: {
  keySet: Record<
    string,
    {
      tag: string
      tagField: string
      isAssignment?: boolean
    }
  >
  isAssignment?: boolean
  isProject?: boolean
}) => {
  const tagSet: string[] = []
  for (const item of Object.keys(keySet)) {
    const tagKey = keySet[item]?.tag
    const isAssignmentValue = keySet[item]?.isAssignment
    if (tagKey) {
      if (isAssignment) {
        isAssignmentValue && tagSet.push(tagKey)
      } else if (isProject) {
        !isAssignmentValue && tagSet.push(tagKey)
      } else {
        tagSet.push(tagKey)
      }
    }
  }
  return tagSet
}

export const passProjectDataIntoAssignment = (
  rootResponseSet: IProjectFlowResponse,
  assignmentInitialData: any,
  bodyInitialData: any,
  isAddAssignmentFlow = false
) => {
  const tagRecords = getTagSetFromGroupedKey({
    verticalResponse: rootResponseSet
  })
  const tagSet = getTagsArray({
    keySet: tagRecords
  })
  const discardedKeys: string[] = [
    'individual',
    'project_title',
    'assignment_title',
    'experience_level'
  ]
  const keySet: string[] = []

  rootResponseSet?.response?.forEach(rootItem => {
    rootItem?.body?.forEach(rootBody => {
      rootBody?.group?.dataset?.forEach(datasetItem => {
        datasetItem?.id &&
          !discardedKeys?.includes(datasetItem?.id) &&
          keySet.push(datasetItem?.id)

        if (datasetItem?.tagField) {
          keySet.push(datasetItem?.tagField)
        }
        if (datasetItem?.subId) {
          keySet.push(datasetItem?.subId)
        }
        if (datasetItem?.tag) {
          keySet.push(datasetItem?.tag)
        }
        if (Number(datasetItem.body?.length) > 0) {
          datasetItem.body?.forEach((subIt: IProjectBody) => {
            subIt?.id &&
              !discardedKeys?.includes(subIt.id) &&
              keySet.push(subIt.id)
            if (subIt?.tagField) {
              keySet.push(subIt.tagField)
            }
            if (subIt?.tag) {
              keySet.push(subIt.tag)
            }
          })
        }
      })
    })
  })
  keySet.push(...['reference_files'])
  let assignmentData: any = {
    ...getCopy(assignmentInitialData)
  }
  const bodyMedianData = getCopy(bodyInitialData)
  keySet?.forEach(keyItem => {
    if (Object.prototype.hasOwnProperty.call(bodyMedianData, keyItem)) {
      if (
        (keyItem === 'references' || keyItem === 'reference_files') &&
        assignmentData[keyItem]
      ) {
        if (
          bodyMedianData[keyItem] &&
          Array.isArray(bodyMedianData[keyItem]) &&
          bodyMedianData[keyItem]?.length > 0
        ) {
          assignmentData[keyItem] = [
            ...assignmentData[keyItem],
            ...bodyMedianData[keyItem]
          ]
        }
      } else {
        if (isAddAssignmentFlow) {
          assignmentData = {
            [keyItem]: bodyMedianData[keyItem],
            ...assignmentData
          }
        } else {
          assignmentData = {
            ...assignmentData,
            [keyItem]: bodyMedianData[keyItem]
          }
        }
      }
    }
  })
  let { reference_files } = assignmentData
  if (!(reference_files && Array.isArray(reference_files))) {
    reference_files = []
  }

  if (bodyMedianData.references && Array.isArray(bodyMedianData.references)) {
    assignmentData.reference_files = [
      ...reference_files,
      ...bodyMedianData.references
    ]
  }

  for (const assignmentKey of Object.keys(assignmentData)) {
    const attachmentSet = assignmentData[assignmentKey]?.attachments ?? []
    if (attachmentSet?.length > 0) {
      // eslint-disable-next-line no-loop-func
      attachmentSet?.forEach(
        (rootAttachmentItem: { id: string; name: string }) => {
          const getMatch = assignmentData.reference_files?.find(
            (refItem: { id: string }) => refItem?.id === rootAttachmentItem.id
          )
          if (!getMatch) {
            const keyTag = tagRecords[assignmentKey]?.tag
            keyTag &&
              assignmentData.reference_files?.push({
                id: rootAttachmentItem.id,
                name: rootAttachmentItem.name,
                tag: keyTag
              })
          }
        }
      )
    }
  }

  assignmentData.other_links =
    assignmentData.reference_files
      ?.filter(
        (refItem: { tag: string; id: string; type: string }) =>
          refItem?.type === 'loomUrl' && tagSet.includes(refItem?.tag)
      )
      ?.map((refItem: { id: string; tag: string }) => {
        return `tag:${refItem?.tag},link:${refItem.id}`
      }) || []
  assignmentData.reference_files = assignmentData.reference_files
    ?.map((refItem: { tag: string; id: string; type: string }) => {
      const { tag, id, type } = refItem
      if (type !== 'loomUrl' && tagSet.includes(tag)) {
        return {
          tag,
          id
        }
      }
      return null
    })
    .filter((refItem: { tag: string }) => refItem?.tag)
  for (const assignmentKey of Object.keys(assignmentData)) {
    if (assignmentData[assignmentKey]?.richText) {
      assignmentData[assignmentKey] = assignmentData[assignmentKey]?.richText
    }
    if (assignmentData[assignmentKey]?.comment) {
      assignmentData[assignmentKey] = assignmentData[assignmentKey]?.comment
    }
    if (assignmentData[assignmentKey]?.attachments) {
      delete assignmentData[assignmentKey]
    }
    if (assignmentData[assignmentKey]?.loomUrls) {
      delete assignmentData[assignmentKey]
    }
  }
  delete assignmentData.references
  return assignmentData
}

export const getAssignmentPayload = ({
  additionalPayload,
  assignmentsList,
  companyId,
  createProjectJSONVersion,
  genre_id,
  translation_languages_target_id,
  rootCategoryID,
  rootExperienceLevel,
  rootVertical,
  selectedPromoCode,
  verticalBasedProcessData,
  additionalExperience,
  content_website_page,
  project_draft_id,
  assignmentStepPosition = 1
}: {
  additionalPayload?: Record<string, any>
  assignmentsList: any
  companyId: string
  createProjectJSONVersion: {
    id: number
    version: string
  }[]
  genre_id: number
  translation_languages_target_id: number[]
  rootCategoryID: number
  rootExperienceLevel: number
  rootVertical: any
  selectedPromoCode: string
  verticalBasedProcessData: any
  additionalExperience?: number
  content_website_page?: string
  project_draft_id?: string
  assignmentStepPosition?: 1 | 2
}) => {
  const groupedAssignments = []
  if (assignmentsList.length > 0 && verticalBasedProcessData) {
    const _assignmentsList = getCopy(assignmentsList)
    for (
      let assignmentIndex = 0;
      assignmentIndex < _assignmentsList?.length;
      assignmentIndex++
    ) {
      const bodyAssignment = _assignmentsList[assignmentIndex]
      if (Number(bodyAssignment?.verticalsSelected?.length) > 0) {
        bodyAssignment.verticalsSelected?.forEach(
          (verticalsSelectedItem: string, index: number) => {
            const verticalSet =
              verticalBasedProcessData?.[verticalsSelectedItem]
            if (!verticalSet) {
              return
            }
            const tempVerticalDt = getAssignmentSpecificBrief(
              verticalSet,
              bodyAssignment,
              assignmentStepPosition
            ) // rootVertical
            if (bodyAssignment.experience_level_design) {
              tempVerticalDt.experience_level =
                bodyAssignment.experience_level_design
            }
            if (bodyAssignment.experience_level_text) {
              tempVerticalDt.experience_level =
                bodyAssignment.experience_level_text
            }
            if (bodyAssignment.experience_level_translation) {
              tempVerticalDt.experience_level =
                bodyAssignment.experience_level_translation
            }

            if (additionalExperience) {
              tempVerticalDt.experience_level = additionalExperience
            }

            groupedAssignments.push({
              ...tempVerticalDt,
              word_count: bodyAssignment?.word_count,
              json_version: createProjectJSONVersion?.find(
                versionItem => versionItem?.id === verticalSet?.id
              )?.version,
              vertical_id: verticalSet?.id,
              category_id: verticalSet?.category
            })
          }
        )
        if (rootVertical?.key) {
          const rootVerticalSet = verticalBasedProcessData?.[rootVertical.key]
          const tempRootVerticalDt = getAssignmentSpecificBrief(
            rootVerticalSet,
            bodyAssignment,
            assignmentStepPosition
          )
          groupedAssignments.push({
            ...tempRootVerticalDt,
            word_count: bodyAssignment?.word_count,
            experience_level: rootExperienceLevel,
            vertical_id: rootVertical?.id,
            json_version: createProjectJSONVersion?.find(
              versionItem => versionItem?.id === rootVertical?.id
            )?.version,
            category_id: rootCategoryID
          })
        }
      } else {
        if (rootVertical) {
          groupedAssignments.push({
            ...bodyAssignment,
            word_count: bodyAssignment?.word_count,
            vertical_id: rootVertical?.id,
            experience_level: rootExperienceLevel,
            json_version: createProjectJSONVersion?.find(
              versionItem => versionItem?.id === rootVertical?.id
            )?.version,
            category_id: rootCategoryID
          })
        }
      }
    }
  }
  const groupedAssignmentsPayment: any = []
  groupedAssignments.forEach(groupedAssignment => {
    if (Number(groupedAssignment.category_id) === 1) {
      groupedAssignmentsPayment.push({
        name: groupedAssignment.assignment_title,
        experience_level: groupedAssignment.experience_level,
        vertical: groupedAssignment.vertical_id,
        genre: genre_id,
        category: 1,
        word_count: groupedAssignment.word_count
          ? Number.parseInt(groupedAssignment.word_count)
          : null,
        extra: groupedAssignment
      })
    } else if (Number(groupedAssignment.category_id) === 2) {
      groupedAssignmentsPayment.push({
        name: groupedAssignment.assignment_title,
        experience_level: groupedAssignment.experience_level,
        vertical: groupedAssignment.vertical_id,
        genre: genre_id,
        category: 2,
        word_count: 0,
        extra: groupedAssignment
      })
    } else if (Number(groupedAssignment.category_id) === 3) {
      translation_languages_target_id?.forEach(
        (translation_language_target: number) => {
          groupedAssignmentsPayment.push({
            name: groupedAssignment.assignment_title,
            experience_level: groupedAssignment.experience_level,
            vertical: groupedAssignment.vertical_id,
            genre: genre_id,
            category: 3,
            word_count: groupedAssignment.word_count
              ? Number.parseInt(groupedAssignment.word_count)
              : null,
            translation_language_target,
            extra: groupedAssignment
          })
        }
      )
    }
    return groupedAssignment
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return {
    ...(content_website_page && {
      content_website_page
    }),
    promo_code: selectedPromoCode,
    company_id: companyId,
    items: [
      {
        type: 'ContentProject',
        includes: groupedAssignmentsPayment
      }
    ],
    ...(additionalPayload && {
      ...additionalPayload
    })
  }
}
